import angular from 'angular';

import ThingsServiceProvider from './../services/things.service';
import DetailComponent from './detail-view';
import GraphComponent from './graph-component';
import NotificationsTableComponent from './notifications-table';
import KnownStateComponent from './known-state-component';
import MapPositionComponent from './map-position';

const module = angular
    .module('app.detail', [])
    .service('ThingsService', ThingsServiceProvider)
    .component(DetailComponent.selector, DetailComponent)
    .component(GraphComponent.selector, GraphComponent)
    .component(NotificationsTableComponent.selector, NotificationsTableComponent)
    .component(KnownStateComponent.selector, KnownStateComponent)
    .component(MapPositionComponent.selector, MapPositionComponent)
    ;

export default module.name;



// WEBPACK FOOTER //
// ./src/app/detail/index.js